import { isRouteAllowedInGroup } from './session'

// Aviso das telas por empresa na visão multi-empresas (menu lateral, menu do
// celular e atalhos do topo). O clique ainda navega: o GroupRouteGuard mostra
// o atalho para entrar numa empresa.
export const GROUP_UNAVAILABLE_HINT =
  'Indisponível em Todas as empresas. Entre numa empresa pelo menu da conta para acessar.'

type GroupMenuSub = {
  router?: string
  tab?: number | string
  query?: { tab?: unknown } | Record<string, unknown>
  groupUnavailable?: boolean
}

type GroupMenuItem = {
  router: string
  subheader?: GroupMenuSub[]
  groupUnavailable?: boolean
}

type MarkedSub<TItem extends GroupMenuItem> = NonNullable<
  TItem['subheader']
>[number] & { groupUnavailable: boolean }

export type GroupMarkedItem<TItem extends GroupMenuItem> = Omit<
  TItem,
  'subheader' | 'groupUnavailable'
> & {
  groupUnavailable: boolean
  subheader?: MarkedSub<TItem>[]
}

/**
 * SC-10999: na visão multi-empresas o menu continua inteiro, mas o que não
 * funciona no grupo fica marcado com `groupUnavailable` (o Drawer esmaece e
 * explica num tooltip). Um item com subitens só fica indisponível quando
 * todos eles estão. O GroupRouteGuard continua sendo a fonte da verdade.
 */
export const markMenuForGroup = <TItem extends GroupMenuItem>(
  items: TItem[]
): GroupMarkedItem<TItem>[] =>
  // O TS não acompanha o spread genérico até o tipo marcado: a forma é a mesma
  items.map((item) => {
    if (!item.subheader?.length) {
      return { ...item, groupUnavailable: !isRouteAllowedInGroup(item.router) }
    }

    const subheader = item.subheader.map((sub) => {
      const tab = (sub.tab ?? sub.query?.tab) as string | undefined
      const allowed = sub.router
        ? isRouteAllowedInGroup(sub.router)
        : isRouteAllowedInGroup(item.router, tab)

      return { ...sub, groupUnavailable: !allowed }
    })

    return {
      ...item,
      subheader,
      groupUnavailable: subheader.every((sub) => sub.groupUnavailable)
    }
  }) as GroupMarkedItem<TItem>[]
